var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgSuccessfully(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 171,
    viewBox: "0 0 188 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8079 97.5104L0 63.7385L89.1852 0L178.37 63.7385L148.086 97.5104H29.8079Z",
    fill: "#85B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8079 97.5104L0 63.7385L89.1852 0L178.37 63.7385L148.086 97.5104H29.8079Z",
    fill: "#514ABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.078 68.0195H0V143.887H174.078V68.0195Z",
    fill: "#85B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.078 68.0195H0V143.887H174.078V68.0195Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.37 171H0V63.7385L89.1852 117.488L178.37 63.7385V171Z",
    fill: "#85B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.616 27.7829L136.699 13.3162L86.5887 78.494L58.7574 57.2101L44.252 76.077L81.5392 104.55L91.1011 111.697L155.616 27.7829Z",
    fill: "#3AD29F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.752158 39.6895L0.0429688 40.0349L0.124523 39.8903L0.0622843 39.9103L0.149562 39.8458L9.69453 22.9047L14.5737 27.0539L18.7595 30.9188L17.5576 31.5041L18.9087 33.881L0.752158 39.6895Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0913 27.4973L17.9172 31.0353L0.576172 39.6335L9.80446 27.8372L14.0913 27.4973Z",
    fill: "#85B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.0913 27.4973L17.9172 31.0353L0.576172 39.6335L9.80446 27.8372L14.0913 27.4973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62871 23.7021L0.576172 39.6334L14.0913 27.4972L9.62871 23.7021Z",
    fill: "#85B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0278 33.7742L0.59375 39.5178L15.1674 28.6677L18.0278 33.7742Z",
    fill: "#85B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.816 9.2112L159.996 15.8155L188.001 20.3635L169.964 7.8363L163.816 9.2112Z",
    fill: "#85B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.816 9.2112L159.996 15.8155L188.001 20.3635L169.964 7.8363L163.816 9.2112Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.414 1.97229L188 20.3635L163.814 9.21113L168.414 1.97229Z",
    fill: "#85B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.029 19.6973L187.925 20.2098L162.817 11.3149L161.029 19.6973Z",
    fill: "#85B8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 87.039,
    y1: 143.887,
    x2: 87.039,
    y2: 68.0195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55135,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.193,
    y1: 39.3989,
    x2: 3.44803,
    y2: 30.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53514,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 171,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSuccessfully);
export default __webpack_public_path__ + "static/media/imgSuccessfully.2a7aaf4c9c605ba0101ce985c58cddc2.svg";
export { ForwardRef as ReactComponent };